import React from 'react';
import styles from './TellYourStory.module.css';

const TellYourStory: React.FC = () => {
  // WhatsApp Handler
  const handleWhatsApp = () => {
    const phoneNumber = '918092938246'; // Replace with your WhatsApp number (country code + number, no spaces)
    const message = encodeURIComponent(
      'Hi Staruprahi Team! I would like to share my startup story with you.\n\nStartup Name: \nFounder Name: \nBrief Description: \n\nLooking forward to connecting!'
    );
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappURL, '_blank');
  };

  // Email Handler
  const handleEmail = () => {
    const recipientEmail = 'startuprahi@gmail.com'; // Replace with your email
    const subject = encodeURIComponent('Submit My Startup Story - Staruprahi');
    const body = encodeURIComponent(
      'Hi Staruprahi Team,\n\nI would like to share my startup story with your audience.\n\n' +
      'Startup Name: \n' +
      'Founder Name: \n' +
      'Website: \n' +
      'Brief Description: \n\n' +
      'What makes our startup unique: \n\n' +
      'Key Achievements: \n\n' +
      'Looking forward to being featured on Staruprahi!\n\n' +
      'Best regards'
    );
    const mailtoURL = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
    window.location.href = mailtoURL;
  };

  return (
    <section className={styles.tellYourStory}>
      <div className={styles.container}>
        <div className={styles.content}>
          {/* Left Side - Text Content */}
          <div className={styles.textContent}>
            <span className={styles.badge}>Share Your Journey</span>
            <h2 className={styles.title}>
              Tell Your <span className={styles.gradient}>Story</span>
            </h2>
            <p className={styles.description}>
              Have an inspiring startup story? We'd love to hear it! Share your journey, 
              challenges, and success with thousands of entrepreneurs and investors.
            </p>

            <div className={styles.features}>
              <div className={styles.feature}>
                <div className={styles.featureIcon}>📢</div>
                <div>
                  <h3>Get Featured</h3>
                  <p>Get 50K+ guaranteed reach</p>
                </div>
              </div>
              <div className={styles.feature}>
                <div className={styles.featureIcon}>🌟</div>
                <div>
                  <h3>Build Credibility</h3>
                  <p>Showcase your startup to investors</p>
                </div>
              </div>
              <div className={styles.feature}>
                <div className={styles.featureIcon}>🤝</div>
                <div>
                  <h3>Connect</h3>
                  <p>Network with industry leaders</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Contact Buttons */}
          <div className={styles.actionContent}>
            <div className={styles.actionCard}>
              <div className={styles.actionHeader}>
                <h3>How to Share Your Story</h3>
                <p>Choose your preferred method to connect with us:</p>
              </div>

              <div className={styles.actionButtons}>
                {/* WhatsApp Button */}
                <button 
                  className={styles.whatsappButton}
                  onClick={handleWhatsApp}
                  aria-label="Contact via WhatsApp"
                >
                  <div className={styles.buttonIcon}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                    </svg>
                  </div>
                  <div className={styles.buttonContent}>
                    <span className={styles.buttonTitle}>WhatsApp</span>
                    <span className={styles.buttonSubtitle}>Quick & Easy</span>
                  </div>
                  <div className={styles.buttonArrow}>→</div>
                </button>

                {/* Email Button */}
                <button 
                  className={styles.emailButton}
                  onClick={handleEmail}
                  aria-label="Contact via Email"
                >
                  <div className={styles.buttonIcon}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                      <polyline points="22,6 12,13 2,6"/>
                    </svg>
                  </div>
                  <div className={styles.buttonContent}>
                    <span className={styles.buttonTitle}>Email</span>
                    <span className={styles.buttonSubtitle}>Detailed Submission</span>
                  </div>
                  <div className={styles.buttonArrow}>→</div>
                </button>
              </div>

              <div className={styles.actionFooter}>
                <p>
                  <strong>Response Time:</strong> We review all submissions within 24-48 hours 
                  and get back to you with feedback or publication timeline.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TellYourStory;